module.exports = __webpack_public_path__ + "64bfcfb3148a65e19af1bd115f721df8.png";


//////////////////
// WEBPACK FOOTER
// ./src/favicon-16.png
// module id = 498
// module chunks = 0